/**
 * ContrattoTemplatePage - Page Shell
 * Form creazione/modifica template contratto
 */

import { useParams } from "react-router-dom";
import { ContrattoTemplateForm } from "@/features/legal";

export default function ContrattoTemplatePage() {
  const { id } = useParams<{ id: string }>();
  
  return (
    <ContrattoTemplateForm 
      id={id} 
      onBack={() => window.location.href = "/contratti"}
      onSaved={() => {
        // Rimani sulla stessa pagina dopo il salvataggio
      }}
    />
  );
}

